import React, { useState } from "react";
import img from "../../icons/amenity.jpg";
import Ac from "../../amentiesImages/Ac.png";
import Breakfast from "../../amentiesImages/Breakfast.png";
import Breakfast2 from "../../amentiesImages/Breakfast2.png";
import Commute from "../../amentiesImages/Commute.png";
import Frontdesk from "../../amentiesImages/Frontdesk.png";
import Gym from "../../amentiesImages/Gym.png";
import HomeService from "../../amentiesImages/RoomService.png";
import Laundry from "../../amentiesImages/Laundry.png";
import Luggae2 from "../../amentiesImages/Business.png";
import Luggage from "../../amentiesImages/Luggage.png";
import Minibar from "../../amentiesImages/RoomService.png";
import Parking from "../../amentiesImages/Parking.png";
import Pet from "../../amentiesImages/Pet.png";
import Spa from "../../amentiesImages/Spa.png";
import Swimming from "../../amentiesImages/Swimming.png";
import Wheelchair from "../../amentiesImages/Wheelchair.png";
import Wifi from "../../amentiesImages/Wifi.png";
import Wine from "../../amentiesImages/Bar.png";
import Tv from "../../amentiesImages/Tv.png";

const iconMap = {
  "Free Wi-Fi": Wifi,
  "Complimentary Breakfast": Breakfast2,
  "Room Service": HomeService,
  "Fitness Center/Gym": Gym,
  "Swimming Pool": Swimming,
  "Business Center": Luggae2,
  "On-Site Restaurant/Bar": Wine,
  "Concierge Service": Breakfast,
  "Parking (Free or Paid)": Parking,
  "Air Conditioning/Heating": Ac,
  "24-Hour Front Desk": Frontdesk,
  "Laundry Services": Laundry,
  "Airport Shuttle Service": Commute,
  "Pet-Friendly Accommodations": Pet,
  "Mini-Bar": Minibar,
  "Spa/Wellness Center": Spa,
  "Cable/Satellite TV": Tv,
  "Luggage Storage": Luggage,
  "Wheelchair Accessibility": Wheelchair,
};
// console.log("Number", amenities);
const HorizontalScroll = ({ amenities }) => {
  console.log(amenities);
  amenities.forEach((a) => {
    if (!iconMap[a.name]) {
      console.log(a.name);
    }
  });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  return (
    <div className="flex justify-start items-start overflow-x-auto">
      <div className="flex px-6">
        {amenities.map(
          (amenity, index) =>
            amenity.enabled && (
              <div key={index} className="w-20 mt-2 flex flex-col items-center">
                <img
                  onClick={() => setHoveredIndex(index)}
                  src={amenity.image}
                  alt={amenity.name}
                  className="w-16 h-16 object-contain transition-transform hover:scale-110"
                />
                {/* <span className="text-center text-white text-sm mt-2">
                  {amenity.name}
                </span> */}
              </div>
            ),
        )}
      </div>
    </div>
  );
};

export default HorizontalScroll;
